export const aboutKeys = {
  // Hero
  heroHeadline: "heroHeadline",
  heroSubtitle: "heroSubtitle",
  heroCta: "heroCta",
  heroOpenRoles: "heroOpenRoles",

  // Problem
  problemLabel: "problemLabel",
  problemHeadline: "problemHeadline",
  problemBody: "problemBody",
  problemStatValue: "problemStatValue",
  problemStatDesc: "problemStatDesc",
  problemStatSource: "problemStatSource",
  problemStat2Value: "problemStat2Value",
  problemStat2Text: "problemStat2Text",

  // Approach
  approachLabel: "approachLabel",
  approachHeadline: "approachHeadline",
  pillar1Title: "pillar1Title",
  pillar1Desc: "pillar1Desc",
  pillar1Cta: "pillar1Cta",
  pillar2Title: "pillar2Title",
  pillar2Desc: "pillar2Desc",
  pillar2Cta: "pillar2Cta",
  pillar3Title: "pillar3Title",
  pillar3Desc: "pillar3Desc",
  pillar3Cta: "pillar3Cta",

  // Values
  valuesLabel: "valuesLabel",
  valuesHeading: "valuesHeading",
  valueTrustedSidekickName: "valueTrustedSidekickName",
  valueTrustedSidekickDesc: "valueTrustedSidekickDesc",
  valueAlwaysThereName: "valueAlwaysThereName",
  valueAlwaysThereDesc: "valueAlwaysThereDesc",
  valueBetterEveryDayName: "valueBetterEveryDayName",
  valueBetterEveryDayDesc: "valueBetterEveryDayDesc",
  valueActionablyProactiveName: "valueActionablyProactiveName",
  valueActionablyProactiveDesc: "valueActionablyProactiveDesc",
  valueGrittyName: "valueGrittyName",
  valueGrittyDesc: "valueGrittyDesc",
  valueThinkBigName: "valueThinkBigName",
  valueThinkBigDesc: "valueThinkBigDesc",

  // Team
  teamLabel: "teamLabel",
  teamHeadline: "teamHeadline",
  teamSubtitle: "teamSubtitle",
  advisoryBoardLabel: "advisoryBoardLabel",
  medicalPartnerRole: "medicalPartnerRole",
  medicalPartnerTitle: "medicalPartnerTitle",
  advisorCredential1: "advisorCredential1",
  advisorCredential2: "advisorCredential2",
  advisorCredential3: "advisorCredential3",
  advisorCredential4: "advisorCredential4",
  widerTeamLabel: "widerTeamLabel",

  // Leadership titles
  leadershipNickTitle: "leadershipNickTitle",
  leadershipSvenTitle: "leadershipSvenTitle",
  leadershipDennisTitle: "leadershipDennisTitle",
  leadershipVegaTitle: "leadershipVegaTitle",

  // Wider team roles
  widerTeamClinicalOps: "widerTeamClinicalOps",
  widerTeamGpPrevention: "widerTeamGpPrevention",
  widerTeamGpPreventionM: "widerTeamGpPreventionM",
  widerTeamSoftwareEngineer: "widerTeamSoftwareEngineer",
  widerTeamProductDesigner: "widerTeamProductDesigner",
  widerTeamProductMarketer: "widerTeamProductMarketer",
  widerTeamCustomerSuccess: "widerTeamCustomerSuccess",
  widerTeamChiefOfStaff: "widerTeamChiefOfStaff",
  widerTeamHeadOfGrowth: "widerTeamHeadOfGrowth",

  // Angel affiliations (translatable ones only)
  angelHuggingFaceAffiliation: "angelHuggingFaceAffiliation",

  // Investors
  investorsLabel: "investorsLabel",
  investorsHeadline: "investorsHeadline",
  investorsAngelsLabel: "investorsAngelsLabel",

  // Careers
  careersLabel: "careersLabel",
  careersHeadline: "careersHeadline",
  careersSeeRole: "careersSeeRole",
  careersOpenAppTitle: "careersOpenAppTitle",
  careersOpenAppDesc: "careersOpenAppDesc",
  careersOpenAppCta: "careersOpenAppCta",

  // Closing
  closingHeadline: "closingHeadline",
  closingHeadlineBold: "closingHeadlineBold",
  closingCta: "closingCta",
} as const
